module.exports = __webpack_public_path__ + "img/wallpaper-1.2635c896.png";